<template>
  <div class="customer-service-enter" @click="openCustomerServicePage">
    <dol-icon class="customer-service-icon" type="customer" />
    <div class="customer-service-text">{{ $t('客服_联系客服') }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const LANG_MAP = {
  zh: 'cn',
  en: 'en',
  ru: 'ru',
}

export default {
  name: 'customer-service',
  data () {
    return {};
  },
  computed: {
    ...mapState(['userInfo', 'isVisitor']),
    serviceLink(){
      const link = ['https://mdkvip.zaixianvip.net/web/im?cptid=7299344860c1'];
      if(this.userInfo && !this.isVisitor){
        link.push(`visitorid=${this.userInfo.USER_ID}`);
        link.push(`visitorname=${this.$dt(this.userInfo, 'USER_NAME')}`);
        link.push(`address=${this.$dt(this.userInfo, 'COMPANY_NAME')}`);
      }
      link.push(`lng=${LANG_MAP[this.$i18n.locale] || 'cn'}`)

      return link.join('&');
    }
  },
  methods: {
    openCustomerServicePage(){
      window.open(this.serviceLink);
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/constant";
.customer-service-enter{
  position: fixed;
  left: 0;
  bottom: 70px;
  background: #FFFFFF;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  padding: 10px 5px;
  font-size: 33px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $primaryColor;
  cursor: pointer;

  .customer-service-icon{
  }

  .customer-service-text{
    text-align: center;
    margin-top: 5px;
    writing-mode: vertical-lr;
  }
}
</style>